import React from "react";
import { FaFacebook, FaInstagram, FaYoutube, FaGooglePlus } from "react-icons/fa";
import { CiMail } from "react-icons/ci";

interface FooterProps {
  flush?: boolean;
}

const Footer: React.FC<FooterProps> = ({ flush = false }) => {
  return (
    <footer
      className={`w-full font-serif border-t-[6px] border-[#30437A] ${
        flush ? "" : "mt-12 lg:mt-16"
      }`}
    >

      {/* =====================================================
          MOBILE – OTEVÍRACÍ DOBA (TĚLOVÁ BARVA)
      ===================================================== */}
      <div className="block lg:hidden bg-[#f5e6c8] text-[#3b1f0f] px-6 py-10 text-center">

        <h2 className="text-2xl mb-4 font-bold">
          Otevírací doba
        </h2>

        <div className="w-12 h-[2px] bg-[#3b1f0f] mx-auto mb-6 rounded" />

        <div className="space-y-2 text-sm leading-relaxed">
          <p><b>Pondělí</b> – 11:00–20:00 (kuchyně do 19:00)</p>
          <p><b>Úterý</b> – 11:00–20:00 (kuchyně do 19:00)</p>
          <p><b>Středa</b> – 11:00–20:00 (kuchyně do 19:00)</p>
          <p><b>Čtvrtek</b> – 11:00–20:00 (kuchyně do 19:00)</p>
          <p><b>Pátek</b> – 11:00–21:00 (kuchyně do 20:00)</p>
          <p><b>Sobota</b> – 11:00–21:00 (kuchyně do 20:00)</p>
          <p><b>Neděle</b> – 11:00–20:00 (kuchyně do 19:00)</p>
        </div>
      </div>

      {/* =====================================================
          MOBILE – FOOTER
      ===================================================== */}
      <div className="block lg:hidden bg-[#32180d] text-white px-6 py-12 text-center">

        <h2 className="text-2xl mb-6">
          Kontaktní informace
        </h2>

        <img
          src="https://raw.githubusercontent.com/RealHajs/img-targon-cup/refs/heads/main/hospudka-pod-rablinu-logo%20(1).png"
          className="mx-auto mb-8 w-32 brightness-0 invert"
          alt="Hospůdka pod Rablinů"
        />

        <h3 className="text-xl mb-2">Telefon do restaurace</h3>
        <p className="mb-6 text-lg font-bold">+420 608 608 101</p>

        <h3 className="text-xl mb-2">Telefon na ubytování</h3>
        <p className="mb-6 text-lg font-bold">+420 736 253 640</p>

        <h3 className="text-xl mb-2">E-maily</h3>
        <p className="text-yellow-300">info@hospudkapodrablinu.cz</p>
        <p className="text-yellow-300">ubytovani@hospudkapodrablinu.cz</p>
        <p className="text-yellow-300 mb-6">wellness@hospudkapodrablinu.cz</p>

        <h3 className="text-xl mb-4">Sociální sítě</h3>

        <div className="flex justify-center gap-6 text-3xl mb-10">
          <a href="#" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
          <a href="#" target="_blank" rel="noopener noreferrer"><FaFacebook /></a>
          <a href="#" target="_blank" rel="noopener noreferrer"><FaYoutube /></a>
          <a href="#" target="_blank" rel="noopener noreferrer"><FaGooglePlus /></a>
        </div>

        <p className="text-sm">
          © 2020 – 2026 GAMPEIROS s.r.o.
        </p>
      </div>

      {/* =====================================================
          DESKTOP – FOOTER (BEZE ZMĚN)
      ===================================================== */}
      <div className="hidden lg:block bg-[#32180d] text-white py-20">

        <div className="max-w-7xl mx-auto grid grid-cols-3 gap-12 px-12">

          {/* OTEVÍRACÍ DOBA */}
          <div>
            <h3 className="text-2xl mb-3">Otevírací doba</h3>
            <div className="w-12 h-[2px] bg-white mb-6 rounded" />

            <div className="leading-8 text-sm">
              <p><b>Pondělí</b> – 11:00–20:00 (kuchyně do 19:00)</p>
              <p><b>Úterý</b> – 11:00–20:00 (kuchyně do 19:00)</p>
              <p><b>Středa</b> – 11:00–20:00 (kuchyně do 19:00)</p>
              <p><b>Čtvrtek</b> – 11:00–20:00 (kuchyně do 19:00)</p>
              <p><b>Pátek</b> – 11:00–21:00 (kuchyně do 20:00)</p>
              <p><b>Sobota</b> – 11:00–21:00 (kuchyně do 20:00)</p>
              <p><b>Neděle</b> – 11:00–20:00 (kuchyně do 19:00)</p>
            </div>
          </div>

          {/* LOGO */}
          <div className="flex justify-center items-center">
            <img
              src="./img/logo-footer.png"
              className="w-48 brightness-0 invert"
              alt="Hospůdka pod Rablinů"
            />
          </div>

          {/* KONTAKT */}
          <div>
            <h3 className="text-2xl mb-4">Kontakt</h3>

            <p className="mb-2 font-bold">Telefon do restaurace</p>
            <p className="mb-6">+420 608 608 101</p>

            <p className="mb-2 font-bold">Telefon na ubytování</p>
            <p className="mb-6">+420 736 253 640</p>

            <p className="mb-2 font-bold">E-maily</p>
            <a
              href="mailto:info@hospudkapodrablinu.cz"
              className="text-yellow-300 block"
            >
              info@hospudkapodrablinu.cz
            </a>
            <a
              href="mailto:ubytovani@hospudkapodrablinu.cz"
              className="text-yellow-300 block"
            >
              ubytovani@hospudkapodrablinu.cz
            </a>
            <a
              href="mailto:wellness@hospudkapodrablinu.cz"
              className="text-yellow-300 mb-6 block"
            >
              wellness@hospudkapodrablinu.cz
            </a>

            <div className="flex gap-6 text-3xl mt-6">
              <a href="https://www.facebook.com/hospudkapodrablinuofficial/" target="_blank" rel="noopener noreferrer">
                <FaFacebook />
              </a>
              <a href="https://www.instagram.com/hospudka_pod_rablinu/" target="_blank" rel="noopener noreferrer">
                <FaInstagram />
              </a>
              <a href="mailto:info@hospudkapodrablinu.cz">
                <CiMail />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* COPYRIGHT */}
      <div className="bg-[#160d0a] text-white py-3 text-center text-sm">
        © 2020 – 2026 GAMPEIROS s.r.o., IČO: 29251401
      </div>
    </footer>
  );
};

export default Footer;